var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"my-4 px-2 px-sm-1",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"lg":"10","sm":"11"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }